//@ts-nocheck
import {
    Context,
    createContext,
    ReactNode,
    useContext,
    useEffect,
    useState,
    SetStateAction,
    Dispatch,
} from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { denormalizeIntegration as denormalizeTenantIntegration } from 'services/integration'
import { denormalizeLocation } from 'services/locations'
import { denormalizeService } from 'services/service'
import { CURRENCIES } from 'types/currency'
import { denormalizeStaff, Staff } from 'types/staff'
import { Tenant } from 'types/tenant'
import { denormalizePaymentIntegration, TenantIntegration, TenantIntegrationApiOutput } from 'types/tenant-integration'
import { useFetch, postApiRequest, useApiRequest } from 'utils/fetch-helper'
import { FetchMethods } from 'utils/types'
import { default_primary_color, useAuth } from './AuthContext'
import { useRouter } from 'next/router'
import { MembershipApiItem } from 'types/membership'
import { PREFERRED_LANGUAGES, useAppContext } from './AppContext'
import getConfig from 'next/config'
import {
    DEFAULT_LANGUAGE_CODE,
    DEFAULT_LANGUAGE_RECORD,
} from 'components/LanguageSelector'
import { CategoryApiOutput, CategoryTypes } from 'types/category'
import { ServiceItem } from 'types/service'
import { GroupClassApi } from 'components/Modals/types'
import { LocationItem } from 'types/location'
import { NotificationCategory, mapNotificationSettings } from 'types/notification'
import { CalendarSettings, StartDay, CALENDAR_START_DAY, CALENDAR_SHOW_30_MINS, ALLOW_OVERLAP } from 'types/calendar'
import { checkImage } from 'services/pwa'
import { SubscriptionStatus, SubscriptionDto } from 'types/subscription'
import { STRIPE_INTEGRATION_ID } from 'types/common'
import { ENTRY_POINTS, IEntrypointOption } from "components/Modals/CustomBookingPage/EntryPointSelector"
import { ICouponItem } from 'components/Modals/Coupons/types'
import { CURRENCY_KEY, DISPLAY_FORM_TITLE_SUBTITLE, SHOW_INTRO_BORDER, INTRO_MESSAGE_KEY, ENTRY_WITH_CATEGORY_KEY, ENABLE_RECURRING_BOOKINGS, LOCATION_BG_KEY, PRIMARY_COLOR_KEY, BUSINESS_WEBSITE_KEY, ENTRY_POINT_KEY, Setting, BUSINESS_TYPE_KEY, REFERRAL_TYPE_KEY, DEFAULT_BUSINESS_TYPE, DEFAULT_REFERRAL_TYPE, mapSettingFromDTO, SettingDTO, SHOW_SERVICES_INCLUDE_KEY, DEFAULT_SHOW_SERVICES_INCLUDE, DEFAULT_INTRO_MESSAGE, DEFAULT_SHOW_INTRO_BORDER, DEFAULT_ALLOW_OVERLAP } from 'types/settings'
import { default_sidebar_items, SidebarItem } from 'pages/dashboard/Sidebar'
import Cookies from 'js-cookie'
import { RoleTypes } from 'types/staff'

export const BOOKING_PAGE =
    getConfig().publicRuntimeConfig['BOOKING_PAGE_TRANSLATION_ID']

export type TenantContextType = {
    nav_expanded: boolean
    tenant?: Tenant
    setTenant(t: Tenant): void
    getTenant: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    expandNav(nav_expanded: boolean): void
    integrations?: TenantIntegration[]
    entitlements: any
    getEntitlements: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    locations: LocationItem[]
    getLocations: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    getAllMenuSettings: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    getMenuAccess: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    setLocations(ls: LocationItem[]): void
    is_loading_locations: boolean
    all_services: ServiceItem[]
    services: ServiceItem[]
    getServices: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    all_staff: any[]
    staff: any[] // active staff only
    getAllStaff: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    all_memberships: MembershipApiItem[]
    getAllMemberships: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    db_settings: any
    getDbSettings: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    data_item_prices: any[]
    getDataItemPrices: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    tenant_integrations: any
    getIntegrations: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    tenant_subdomains: any
    getTenantSubdomains: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    getTenantSubscriptions: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    refetchCoupons: boolean
    setRefetchCoupons: Dispatch<SetStateAction<boolean>>
    stripe_connected_account_id: string | undefined | null
    setStripeConnectedAccountId(stripe: string | undefined): void
    primaryColor: string
    setPrimaryColor: Dispatch<SetStateAction<string>>
    default_booking_url: string
    imageDimensions: { height: any; width: any }
    setImageDimensions(t: { height: any; width: any }): void
    locationBg: string | undefined
    setLocationBg: Dispatch<SetStateAction<string | undefined>>
    preferred_languages: Record<string, string>[]
    bookingPageContent: any
    getBookingPageContent: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    service_categories: CategoryApiOutput[]
    getServiceCategories: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    membership_categories: CategoryApiOutput[]
    getMembershipCategories: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    group_classes: GroupClassApi[]
    getGroupClasses: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    payment_integrations: TenantIntegration[]
    getPaymentIntegrations(category_id: string): void
    location_payment_integrations: Record<string, TenantIntegration[]>
    toggleFreeTier(free: boolean): void
    is_free_tier: boolean
    force_recache_calendar: boolean
    toggleForceRecacheCalendar(toggle: boolean): void
    notification_setting_categories: NotificationCategory[] | undefined
    setNotificationSettingCategories(categories: NotificationCategory[]): void
    getNotificationSettingCategories: (setting_id?: string) => void
    coupons: ICouponItem[]
    getCoupons: (
        body?: any,
        query?: string,
        headers?: any
    ) => Promise<Response | undefined>
    install_prompt: any
    show_install: boolean
    calendar_settings: CalendarSettings
    setCalendarSettings: (settings: CalendarSettings) => void
    stripe_promise?: any
    display_form_title_subtitle: boolean
    toggleDisplayFormTitleSubtitle(toggle: boolean): void
    enable_recurring_bookings: boolean
    toggleEnableRecurringBookings(toggle: boolean): void
    defaultCurrency?: string
    business_website_url?: string
    entry_point: IEntrypointOption
    allow_entry_by_category: boolean
    payment_category: CategoryApiOutput
    business_type: Setting
    referral_type: Setting
    show_services_include: Setting
    intro_message: Setting
    show_intro_border: Setting
    allow_overlap: Setting
    toggleAllowOverlap(setting: Setting): void
    sidebar_items: SidebarItem[]
    setSidebarItems(items: SidebarItem[]): void
    subscription_tenant_status: any
    setSubscriptionTenantStatus: (status: any) => void
    active_tenant_obj: any
    setActiveTenantObj: (id: any) => void
}

const TenantContext: Context<TenantContextType> = createContext(
    {} as TenantContextType
)

export function useTenantContext() {
    return useContext(TenantContext)
}

export function TenantContextProvider({
    children,
}: {
    children: ReactNode
}) {
    const router = useRouter()
    const { getApiRequest } = useApiRequest()
    const {
        translations,
        setTranslations,
        locale,
        languages,
        integration_categories
    } = useAppContext()
    const {
        toggleDrawerSize
    } = useAuth()
    const { STRIPE_PUBLISHABLE_KEY, BOOKING_HOST, NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

    const [tenant, setTenant] = useState<Tenant>({} as unknown as Tenant)
    const [is_free_tier, toggleFreeTier] = useState<boolean>(false)
    const [primaryColor, setPrimaryColor] = useState<string>(
        default_primary_color
    )
    const [default_booking_url, setDefaultBookingUrl] = useState<string>(
        default_primary_color
    )
    const [preferred_languages, setPreferredLanguages] = useState<
        Record<string, string>[]
    >([])
    const [locationBg, setLocationBg] = useState<string>()
    const [defaultCurrency, setDefaultCurrency] = useState(
        CURRENCIES[1].iso as string
    )
    const [business_website_url, setBusinessWebsiteUrl] = useState<string | undefined>()
    const [refetchCoupons, setRefetchCoupons] = useState(false)
    const [stripe_connected_account_id, setStripeConnectedAccountId] =
        useState<string>()
    const [booking_page_content, setBookingPageContent] = useState<[{}]>([
        {},
    ])
    const [service_categories, setServiceCategories] = useState<CategoryApiOutput[]>([])
    const [membership_categories, setMembershipCategories] = useState<CategoryApiOutput[]>([])
    const [payment_category, setPaymentCategory] = useState<CategoryApiOutput>()
    const [payment_integrations, setPaymentIntegrations] = useState<TenantIntegration[]>([])
    const [location_payment_integrations, setLocationPaymentIntegrations] = useState<Record<string, TenantIntegration[]>>([])
    const [locations, setLocations] = useState<LocationItem[]>()
    const [all_services, setAllServices] = useState<ServiceItem[]>()
    const [force_recache_calendar, toggleForceRecacheCalendar] = useState<boolean>(false)
    const [notification_setting_categories, setNotificationSettingCategories] = useState<NotificationCategory[]>()
    const [saving_setting_id, setSavingSettingId] = useState<string>()
    const [coupons, setCoupons] = useState<ICouponItem[]>([])
    const [calendar_settings, setCalendarSettings] = useState<CalendarSettings>({ start_day: StartDay.MONDAY, show_30_min: false })
    const [entry_point, setEntryPoint] = useState<IEntrypointOption>(ENTRY_POINTS[0])
    const [allow_entry_by_category, toggleAllowEntryByCategory] = useState<boolean>(false)
    const [business_type, setBusinessType] = useState<Setting>(DEFAULT_BUSINESS_TYPE)
    const [referral_type, setReferralType] = useState<Setting>(DEFAULT_REFERRAL_TYPE)
    const [show_services_include, toggleShowServicesInclude] = useState<Setting>(DEFAULT_SHOW_SERVICES_INCLUDE)
    const [intro_message, setIntroMessage] = useState<Setting>(DEFAULT_INTRO_MESSAGE)
    const [show_intro_border, toggleShowIntroBorder] = useState<Setting>(DEFAULT_SHOW_INTRO_BORDER)
    const [allow_overlap, toggleAllowOverlap] = useState<Setting>(DEFAULT_ALLOW_OVERLAP)

    const [sidebar_items, setSidebarItems] = useState<SidebarItem[]>([])

    const [stripe_promise, setStripePromise] = useState<any>()
    const [booking_page_default_contents, setBookingPageDefaultContents] = useState<Record<string, string>[]>({})
    const [display_form_title_subtitle, toggleDisplayFormTitleSubtitle] = useState<boolean>(false)
    const [enable_recurring_bookings, toggleEnableRecurringBookings] = useState<boolean>(true)
    const [current_subdomain, setSubdomain] = useState<string>("")
    const subdomain_regex = new RegExp(/^https?:\/\/(.*?)(\..*?)?\.dev\.aot\.plus/g);

    const default192ImgUrl =
        `https://${NEXT_PUBLIC_STATIC_DOMAIN}/images/aot_logo_markonly_transparent_192x192.png`
    const [imageDimensions, setImageDimensions] = useState<any>({})
    const [active_tenant_obj, setActiveTenantObj] = useState({})
    const [subscription_tenant_status, setSubscriptionTenantStatus] = useState<any>()


    // let newVariable: any;
    // newVariable = window.navigator;

    // Detects if device is on iOS
    // const isIos = () => {
    //     const userAgent = window.navigator.userAgent.toLowerCase();
    //     return /iphone|ipad|ipod/.test(userAgent);
    // }

    // Detects if device is in standalone mode
    // const isInStandaloneMode = () => (newVariable && newVariable.standalone);

    // Checks if should display install popup notification:
    // if (isIos() && !isInStandaloneMode()) {
    // Render "Add to home pop up for Apples" - this code is not working to get a popup
    // this.setState({ showInstallMessage: true });
    // }

    const {
        data: all_staff_xhr,
        doFetch: getAllStaff,
    } = useFetch(
        `/v1/staff/with-deleted-items?tenantId=${tenant?.id}&size=500`,
        FetchMethods.GET,
        false
    )

    const {
        data: all_memberships_xhr,
        doFetch: getAllMemberships,
    } = useFetch(
        `/v1/memberships/by-tenant-id?tenantId=${tenant?.id}&includeAll=true`,
        FetchMethods.GET,
        false
    )

    const {
        data: all_services_xhr,
        doFetch: getServices,
    } = useFetch(
        `/v1/services/with-deleted-items?size=500&tenantId=${tenant?.id}`,
        FetchMethods.GET,
        false
    )

    const {
        data: locations_xhr,
        is_loading: is_loading_locations,
        doFetch: getLocations,
    } = useFetch(
        `/v1/locations/tenant-id/?tenantId=${tenant?.id}`,
        FetchMethods.GET,
        false
    )

    const {
        data: tenant_integrations,
        doFetch: getIntegrations,
        status: integration_api_status
    } = useFetch(
        `/v1/tenant-integrations/tenant-id?tenantId=${tenant?.id}&size=501`,
        FetchMethods.GET,
        false
    )

    const {
        data: db_settings,
        doFetch: getDbSettings
    } = useFetch(
        `/v1/settings?tenantId=${tenant?.id}&size=500`,
        FetchMethods.GET,
        false
    )

    const {
        data: tenant_subdomains,
        doFetch: getTenantSubdomains
    } = useFetch(
        `/v1/tenant-domains/by-tenant-id?tenantID=${tenant?.id}`,
        FetchMethods.GET,
        false
    )

    const {
        data: tenant_xhr,
        doFetch: getTenant,
    } = useFetch(
        `/v1/tenants/get-by-id`,
        FetchMethods.GET,
        false
    )

    const {
        data: entitlements,
        doFetch: getEntitlements
    } = useFetch(
        `/v1/tenant/entitlements/?size=500&tenantId=${tenant?.id}`,
        FetchMethods.GET,
        false
    )

    const {
        data: data_item_prices,
        doFetch: getDataItemPrices
    } = useFetch(
        `/v1/chargebee/item-prices?limit=100`,
        FetchMethods.GET,
        false
    )

    const {
        data: booking_page_content_xhr,
        doFetch: getBookingPageContent,
    } = useFetch(
        `/v1/contents?pageName=BOOKING_PAGE&tenantId=${tenant?.id}`,
        FetchMethods.GET,
        false
    )

    // const {
    //     data: google_page_content_xhr,
    //     doFetch: getGooglePageContent,
    // } = useFetch(
    //     `/v1/contents?pageName=GOOGLE_ID&tenantId=${tenant?.id}`,
    //     FetchMethods.GET,
    //     false
    // )

    const {
        data: service_categories_xhr,
        doFetch: getServiceCategories
    } = useFetch(
        `/v1/categories/by-type?size=500&type=SERVICE&tenantId=${tenant?.id}`,
        FetchMethods.GET,
        false
    )

    const {
        data: membership_categories_xhr,
        doFetch: getMembershipCategories
    } = useFetch(
        `/v1/categories/by-type?size=500&type=MEMBERSHIP&tenantId=${tenant?.id}`,
        FetchMethods.GET,
        false
    )

    const {
        data: group_classes_xhr,
        doFetch: getGroupClasses
    } = useFetch(
        `/v1/group_classes/?size=500&tenantId=${tenant?.id}`,
        FetchMethods.GET,
        false
    )

    const {
        data: notification_settings_xhr,
        is_loading: notification_settings_is_loading,
        doFetch: getNotificationSettingsXhr
    } = useFetch(
        `/v1/notification/settings?size=500&tenantId=${tenant?.id}`,
        FetchMethods.GET,
        false
    )

    const {
        data: coupons_xhr,
        doFetch: getCoupons
    } = useFetch(
        `/v1/coupons/by-tenant-id?tenantId=${tenant?.id}`,
        FetchMethods.GET,
        false
    )

    const { data: subdomain_mapping, doFetch: getTenantFromSubdomain } = useFetch(
        `/v1/tenant-domains?subdomain=${current_subdomain}`,
        FetchMethods.GET,
        false
    );

    const { data: all_menu_settings, doFetch: getAllMenuSettings } = useFetch(
        `/v1/menusettings`,
        FetchMethods.GET,
        false
    )

    const { data: menu_access, doFetch: getMenuAccess } = useFetch(
        `/v1/menusettings/get-by-tenant_id?tenantId=${tenant?.id}`,
        FetchMethods.GET,
        false
    )
    
    const { data: tenant_subscriptions, doFetch: getTenantSubscriptions } = useFetch(
        `/v1/tenants/subscriptions/get-tenant-subscription/${tenant?.id}`,
        FetchMethods.GET,
        false
    ) 

    function updateVisibility(menu_access: any[], matchedItems: any[]) {
        // If menu_access is an empty array, return matchedItems as is
        if (menu_access.length === 0) {
            return matchedItems;
        }
    
        // Map through matchedItems and create the result
        const result = matchedItems.map(item => {
            if (item.translation_key) {
                // Find the matching key from menu_access using find
                const matchedAccess = menu_access.find(accessItem => accessItem.key === item.translation_key);
                
                if (matchedAccess) {
                    // Return the item with the key from menu_access
                    return {
                        ...item,
                        is_hidden: false
                    };
                } else {
                    return {
                        ...item,
                        is_hidden: true
                    };
                }
            }
            // If no translation_key or no match, return the item as is
            return item;
        });
    
        return result;
    }
    


    useEffect(() => {
        const drawer_items = default_sidebar_items.map((item) => {
            if (item.route == '/') {
                return {
                    ...item,
                    selected: item.route === location.pathname,
                }
            }
            if (!item.icon && !item.route && !item.separator) {
                return {
                    ...item,
                    onClickCapture: () => {
                        Cookies.set('drawer', 'expanded')
                        toggleDrawerSize(true)
                    },
                }
            }
            const [, , page] = location.pathname.split('/')
            const selected = !!(
                item.route && `/dashboard/${page}` == item.route
            )

            return {
                ...item,
                selected,
            }
        })
        drawer_items.push({ expand_button: true, onClickCapture: () => { } })
        if (
            Array.isArray(all_menu_settings) &&
            all_menu_settings.length > 0 &&
            Array.isArray(menu_access)
        ) {
            const matchedItems = drawer_items.reduce((acc, item) => {
                // If the item has a translation_key, find the corresponding moduleSetting
                if (item.translation_key) {
                    const matchedModule = all_menu_settings.find(mod => mod.key === item.translation_key);
                    if (matchedModule) {
                        acc.push(item);
                    }
                } else {
                    acc.push(item); // Return the item as is if it doesn't have translation_key
                }
                return acc;
            }, [])
            const result = updateVisibility(menu_access, matchedItems)
            setSidebarItems(result)
        }
    }, [translations, all_menu_settings, menu_access])

    useEffect(() => {
        if (sidebar_items.length > 0) {
            let index = sidebar_items.findIndex((item) => item.translation_key == 'booking_page')
            if (index > -1) {
                sidebar_items[index].external_link = default_booking_url
                setSidebarItems(sidebar_items)
            }
        }
    }, [default_booking_url, sidebar_items])
    useEffect(() => {
        if (Object.keys(tenant_subscriptions).length > 0) {
            console.log(active_tenant_obj,"active")
   
            if (Object.keys(active_tenant_obj).length > 0 &&
                active_tenant_obj.hasOwnProperty("roles") &&
                !active_tenant_obj.roles.includes(RoleTypes.SUPER_ADMIN)) {
                    
                if (typeof tenant_subscriptions.status === 'string') {
   
                    if (tenant_subscriptions.status.toLowerCase() === 'cancelled') {
                        toggleFreeTier(true);  // This should be triggered if the status matches
                    }
                }
            }
   
            setSubscriptionTenantStatus(tenant_subscriptions);
        }
    }, [tenant_subscriptions, active_tenant_obj]);

    useEffect(() => {
        getApiRequest(`/v1/contents?pageName=BOOKING_PAGE`).then(content => {
            if (content?.title) {
                setBookingPageDefaultContents(content)
            }
        })
    }, [])

    useEffect(() => {
        if (tenant?.id) {
            getDbSettings()
            getTenantSubdomains()
            getIntegrations()
            getEntitlements()
            getLocations()
            getAllStaff()
            getAllMemberships()
            getServices()
            getServiceCategories()
            getMembershipCategories()
            getGroupClasses()
            getCoupons()
            getBookingPageContent()
            // getGooglePageContent()
            getTenantSubscriptionStatus()
            getAllMenuSettings()
            getMenuAccess()
            getTenantSubscriptions()
        }
    }, [tenant.id])

    useEffect(() => {
        if (notification_settings_xhr?.content?.length > 0) {
            setNotificationSettingCategories(mapNotificationSettings(notification_settings_xhr.content, saving_setting_id))
        } else if (notification_settings_xhr?.empty && tenant?.id) {
            initializeNotifications(tenant.id)
        }
        setSavingSettingId(undefined)
    }, [notification_settings_xhr])

    async function initializeNotifications(tenant_id: string) {
        let res = await postApiRequest(`/v1/notification/settings/tenant-default-templates?tenantId=${tenant?.id}`)
        if (res?.ok) {
            setNotificationSettingCategories(mapNotificationSettings(res))
        }
    }

    function getNotificationSettingCategories(setting_id?: string) {
        if (!notification_settings_is_loading && tenant?.id) {
            getNotificationSettingsXhr()
            if (setting_id) {
                setSavingSettingId(setting_id)
            }
        }
    }


    async function getTenantSubscriptionStatus() {
        let new_is_free_tier = true
        try {
            let chargebee_subscriptions = await getApiRequest(`/v1/chargebee/subscriptions?customerId=${tenant?.chargebeeCustomerId}`)
            if (chargebee_subscriptions) {
                let active_subscription = chargebee_subscriptions.find(
                    (s: SubscriptionDto) => {
                        return (
                            s.status === SubscriptionStatus.ACTIVE
                        )
                    }
                )
                new_is_free_tier = active_subscription && active_subscription.subscription_items?.[0]?.amount == 0
            }
        } catch (error) {
            new_is_free_tier = true
        } finally {
            if (is_free_tier != new_is_free_tier) {
                // toggleFreeTier(new_is_free_tier)
            }
        }
    }

    useEffect(() => {
        if (integration_categories?.length > 0) {
            const payment_category = integration_categories.find(
                (category: CategoryApiOutput) =>
                    category.name.toLocaleLowerCase() == 'payment')
            if (payment_category?.id) {
                setPaymentCategory(payment_category)
                getPaymentIntegrations(payment_category.id)
            }
        }
    }, [integration_categories, tenant?.id])

    async function getPaymentIntegrations(payment_category_id: string) {
        let ret: TenantIntegration[] = []
        if (tenant?.id) {
            const results: TenantIntegrationApiOutput[] = await getApiRequest(
                `/v1/tenant-integrations/by-category?categoryId=${payment_category_id}&tenantId=${tenant?.id}`
            )

            if (results && results?.length > 0) {
                ret = results.map((p: TenantIntegrationApiOutput) => denormalizePaymentIntegration(p))
                setPaymentIntegrations(ret)
            } else {
                setPaymentIntegrations([])
            }
        }
    }

    useEffect(() => {
        if (payment_category?.id) {
            getPaymentIntegrations(payment_category.id)
        }
    }, [is_free_tier])

    useEffect(() => {
        if (locations?.length > 0) {
            let ret: Record<string, TenantIntegration[]> = {}
            locations.forEach(async (location) => { //TODO: should ask BE for a get all endpoint
                const { content } = await getApiRequest(
                    `/v1/tenant-integrations/by-location-id?locationId=${location.id}`
                )
                if (content) {
                    const records = content.map((p: TenantIntegrationApiOutput) => denormalizePaymentIntegration(p))
                    ret[location.id] = records
                }
            })
            setLocationPaymentIntegrations(ret)
        }
    }, [locations])

    useEffect(() => {
        if (locations_xhr?.content) {
            setLocations(locations_xhr.content.map(denormalizeLocation))
        }
    }, [locations_xhr?.content])

    useEffect(() => {
        if (all_services_xhr?.content) {
            setAllServices(all_services_xhr.content.map(denormalizeService))
        }
    }, [all_services_xhr?.content])

    useEffect(() => {
        if (service_categories_xhr?.content) {
            setServiceCategories(service_categories_xhr.content)
        }
    }, [service_categories_xhr])

    useEffect(() => {
        if (membership_categories_xhr?.content) {
            setMembershipCategories(membership_categories_xhr.content)
        }
    }, [membership_categories_xhr])

    useEffect(() => {
        if (
            booking_page_content_xhr?.tenant_id &&
            booking_page_default_contents?.en?.length > 0 &&
            (translations.lang !== locale || !translations[BOOKING_PAGE])
        ) {
            const default_booking_content =
                booking_page_default_contents[locale] || booking_page_default_contents[DEFAULT_LANGUAGE_CODE] || []
    
            const tenant_booking_content =
                (booking_page_content_xhr[locale] || booking_page_content_xhr[DEFAULT_LANGUAGE_CODE] || [])
                    .filter(translation => translation.value)
    
            const default_reduced = default_booking_content.length > 0
                ? default_booking_content.reduce((map, d) => {
                    map[d.key] = d.value
                    return map
                }, {})  // Ensure reduce returns an object
                : {}
    
            const tenant_reduced = tenant_booking_content.length > 0
                ? tenant_booking_content.reduce((map, d) => {
                    map[d.key] = d.value
                    return map
                }, {})  // Ensure reduce returns an object
                : {}
    
            const newTranslations = {
                ...translations,
                ...default_reduced,
                ...tenant_reduced,
                BOOKING_PAGE,
                lang: locale,
            }
    
            // Only update state if there are actual changes
            if (JSON.stringify(translations) !== JSON.stringify(newTranslations)) {
                setTranslations(newTranslations)
            }
        }
    }, [
        booking_page_content_xhr,
        booking_page_default_contents,
        locale,
        translations
    ])
    

    useEffect(() => { //TODO: fix the errors so we can remove the ts-nocheck
        if (booking_page_default_contents?.[DEFAULT_LANGUAGE_CODE]
            && booking_page_content_xhr?.tenant_id
            && preferred_languages?.length > 0) {

            const languages = preferred_languages.map(lang => lang.code).concat(DEFAULT_LANGUAGE_CODE)
            const translation_map = {}

            languages.forEach((lang) => {
                const default_translations = booking_page_default_contents[lang]
                if (default_translations) {
                    default_translations.map(translation => {
                        let content = translation_map[translation.key] || {}
                        content[lang] = translation.value
                        translation_map[translation.key] = content
                    })
                }

                const tenant_translations = booking_page_content_xhr[lang]
                if (tenant_translations) {
                    tenant_translations.map(translation => {
                        let content = translation_map[translation.key] || {}
                        content[lang] = translation.value
                        translation_map[translation.key] = content
                    })
                }
            })

            const mapped_content: any = Object.keys(translation_map).map(key => {
                return {
                    key: key,
                    ...translation_map[key]
                }
            })

            setBookingPageContent(mapped_content)
        }
    }, [
        booking_page_content_xhr,
        booking_page_default_contents,
        preferred_languages,
    ])

    // useEffect(() => {
    //     if (google_page_content_xhr?.en) {
    //         setTenant({
    //             ...tenant,
    //             googleId: google_page_content_xhr.en[0].value
    //         })
    //     }
    // }, [google_page_content_xhr])

    useEffect(() => {
        if (!!router?.query?.t) { // has id, override tenant
            getTenant(undefined, `?id=${router.query.t}`)
        }
    }, [router?.query?.t]) //TODO: find a better dep


    useEffect(() => {
        if (!router?.query?.t && router.pathname.includes("/book")) { // no id but in booking page
            let match = subdomain_regex.exec(window.location.href)
            let subdomain = match && match[1]
            if (subdomain && current_subdomain != subdomain) {
                setSubdomain(subdomain)
            }
        }
    }, [router.pathname])

    useEffect(() => {
        if (current_subdomain?.length > 0) {
            getTenantFromSubdomain()
        }
    }, [current_subdomain])

    useEffect(() => {
        if (subdomain_mapping?.tenantId && !tenant?.id) {
            getTenant(undefined, `?id=${subdomain_mapping?.tenantId}`)
        }
    }, [subdomain_mapping])

    useEffect(() => {
        if (tenant_xhr?.id) {
            setTenant(tenant_xhr)
        }
    }, [tenant_xhr])

    useEffect(() => {
        if (all_staff_xhr?.content) {
            ctx.all_staff = denormalizeStaff(all_staff_xhr)
            ctx.staff = ctx.all_staff.filter(
                (staff: Staff) => !staff.is_deleted
            )
        }
    }, [all_staff_xhr.content])

    useEffect(() => {
        if (all_memberships_xhr?.length > 0) {
            ctx.all_memberships = all_memberships_xhr
        }
    }, [all_memberships_xhr])

    useEffect(() => {
        if (integration_api_status == 200) {
            ctx.integrations = tenant_integrations.content.map(
                denormalizeTenantIntegration
            )
            const stripe_integration = tenant_integrations.content.find(i => i.integrationId == STRIPE_INTEGRATION_ID && !i.locationId)
            if (stripe_integration) {
                const account_id = stripe_integration.connectedAccountId
                ctx.setStripeConnectedAccountId(account_id)
                setStripePromise(loadStripe(STRIPE_PUBLISHABLE_KEY, {
                    stripeAccount: account_id
                }))
            } else {
                ctx.setStripeConnectedAccountId(null)
                setStripePromise(loadStripe(STRIPE_PUBLISHABLE_KEY))
            }
        }
    }, [integration_api_status])

    useEffect(() => {
        if (coupons_xhr) {
            setCoupons(coupons_xhr)
        }
    }, [coupons_xhr])


    useEffect(() => {
        if (tenant?.id && tenant_subdomains.length) {
            const url = `https://${tenant_subdomains[0].subdomain}.${BOOKING_HOST}/book/?t=${tenant?.id}`
            setDefaultBookingUrl(url)
        } else {
            setDefaultBookingUrl(
                window.location.origin + `/book/?t=${tenant?.id}`
            )
        }
    }, [tenant_subdomains])

    useEffect(() => {
        let new_currency = defaultCurrency
        let new_settings: CalendarSettings = { start_day: StartDay.MONDAY, show_30_min: false }
        if (db_settings?.content?.length > 0) {
            (db_settings.content as SettingDTO[]).forEach((item: SettingDTO) => {
                if (item?.name) {
                    switch (item.name) {
                        case CURRENCY_KEY:
                            new_currency = item.value as string
                            break
                        case PRIMARY_COLOR_KEY:
                            setPrimaryColor(item.value || default_primary_color)
                            break
                        case LOCATION_BG_KEY:
                            setLocationBg(item.value)
                            break
                        case CALENDAR_START_DAY:
                            new_settings.start_day_id = item.id
                            new_settings.start_day = (Object.values(StartDay).includes(item.value as StartDay) ? item.value as StartDay : StartDay.MONDAY)
                            break
                        case CALENDAR_SHOW_30_MINS:
                            new_settings.show_30_min_id = item.id
                            new_settings.show_30_min = (item.value == 'true' ? true : false)
                            break
                        case DISPLAY_FORM_TITLE_SUBTITLE:
                            toggleDisplayFormTitleSubtitle(item.value == "true")
                            break
                        case ENABLE_RECURRING_BOOKINGS:
                            toggleEnableRecurringBookings(item.value == "true")
                            break
                        case BUSINESS_WEBSITE_KEY:
                            setBusinessWebsiteUrl(item.value)
                            break
                        case ENTRY_POINT_KEY:
                            setEntryPoint(
                                ENTRY_POINTS.find(
                                    (entry_point) => entry_point.value === item.value
                                ) as IEntrypointOption
                            )
                            break
                        case ENTRY_WITH_CATEGORY_KEY:
                            toggleAllowEntryByCategory(item.value == "true")
                            break
                        case BUSINESS_TYPE_KEY:
                            setBusinessType(mapSettingFromDTO(item, item.value))
                            break
                        case REFERRAL_TYPE_KEY:
                            setReferralType(mapSettingFromDTO(item, item.value))
                            break
                        case SHOW_SERVICES_INCLUDE_KEY:
                            toggleShowServicesInclude((mapSettingFromDTO(item, item.value == "true")))
                            break
                        case INTRO_MESSAGE_KEY:
                            setIntroMessage(mapSettingFromDTO(item, item.value))
                            break
                        case SHOW_INTRO_BORDER:
                            toggleShowIntroBorder(mapSettingFromDTO(item, item.value == "true"))
                            break
                        case ALLOW_OVERLAP:
                            toggleAllowOverlap(mapSettingFromDTO(item, item.value == "true"))
                            break
                        default:
                            // do nothing with extra settings
                            break
                    }
                }
            })
        }

        setDefaultCurrency(new_currency)
        localStorage.setItem('default_currency', new_currency)

        setCalendarSettings(new_settings)
    }, [db_settings])

    useEffect(() => {
        if (db_settings?.content && languages) {
            const pref_lang_temp = db_settings?.content?.find(
                (item: any) => item.name === PREFERRED_LANGUAGES
            )?.value
            if (pref_lang_temp && pref_lang_temp.length > 0) {
                setPreferredLanguages(JSON.parse(pref_lang_temp))
            } else {
                DEFAULT_LANGUAGE_RECORD.id = languages.find(
                    (lang: any) => lang?.locale == locale
                )?.id || ""
                setPreferredLanguages([DEFAULT_LANGUAGE_RECORD])
            }
        }
    }, [db_settings, languages])


    //----------------------------------userEffect start----------------------------------------------------

    const [install_prompt, setInstallPrompt] = useState<any>()
    const [show_install, setShowInstall] = useState(false)

    useEffect(() => {
        if (tenant?.id) {
            if (location.pathname.includes("/book")) {

                window.addEventListener('beforeinstallprompt', function (e) {
                    // Prevent the mini-infobar from appearing on mobile
                    e.preventDefault()
                    // Stash the event so it can be triggered later.
                    setInstallPrompt(e)
                    setShowInstall(false)   // INFO: set to false for now until further notice
                })

                window.addEventListener('appinstalled', async function (e) {
                    setShowInstall(false)
                })

                //check when the page is loaded if it matches one of the PWA display modes
                if (window.matchMedia('(display-mode: standalone)').matches
                    || window.matchMedia('(display-mode: fullscreen)').matches
                    || window.matchMedia('(display-mode: minimal-ui)').matches) {
                    setShowInstall(false)
                }

                //but also add a listener. After app installation on desktop, the app will open in their own window right away.
                try {
                    window.matchMedia('(display-mode: standalone)').addEventListener('change', function (e) {
                        if (e.matches) { setShowInstall(false) }
                    })
                    window.matchMedia('(display-mode: fullscreen)').addEventListener('change', function (e) {
                        if (e.matches) { setShowInstall(false) }
                    })
                    window.matchMedia('(display-mode: minimal-ui)').addEventListener('change', function (e) {
                        if (e.matches) { setShowInstall(false) }
                    })
                } catch (e1) {
                    try {
                        window.matchMedia('(display-mode: standalone)').addListener(function (e) {
                            if (e.matches) { setShowInstall(false) }
                        })
                        window.matchMedia('(display-mode: fullscreen)').addListener(function (e) {
                            if (e.matches) { setShowInstall(false) }
                        })
                        window.matchMedia('(display-mode: minimal-ui)').addListener(function (e) {
                            if (e.matches) { setShowInstall(false) }
                        })
                    } catch (e2) {
                        console.error(e2)
                    }
                }

                // for now commented the code for PN
                // start push alert - in progress
                // var swJS = document.createElement('script');
                // swJS.src = "/pushNotifications/sw.js";
                // document.head.appendChild(swJS);
                // var pnJS = document.createElement('script');
                // pnJS.src = "/pushNotifications/pn.js";
                // document.head.appendChild(pnJS);
                // // end push alert

                // PWA Start
                if (tenant.bizLogoUrl) {
                    var img = new Image()
                    img.src = tenant.bizLogoUrl
                    img.onload = () => {
                        setImageDimensions({
                            height: img.height,
                            width: img.width,
                        })
                        checkImage(img, tenant)
                    }
                } else {
                    var img = new Image()
                    img.src = default192ImgUrl
                    img.onload = () => {
                        setImageDimensions({
                            height: img.height,
                            width: img.width,
                        })
                        checkImage(img, tenant)
                    }
                }

                if ('serviceWorker' in navigator) {
                    navigator.serviceWorker.register('/service-worker.js').then(
                        function (pwaRegistration) {
                            setInterval(function () {
                                pwaRegistration.update()
                            }, 2000)
                            console.log(
                                'Service Worker for PWA registration successful with scope: ',
                                pwaRegistration.scope
                            )
                        },
                        function (err) {
                            setShowInstall(false)
                            console.log(
                                'Service Worker for PWA registration failed: ',
                                err
                            )
                        }
                    )
                }
                // PWA End
            }
        }
    }, [tenant?.id])

    //------------------------------------userEffect End--------------------------------------------------

    let ctx: TenantContextType = {
        nav_expanded: false,
        expandNav: (nav_expanded: boolean) => {
            ctx['nav_expanded'] = nav_expanded
            ctx = {
                ...ctx,
            }
        },
        entitlements,
        getEntitlements,
        locations,
        getLocations,
        setLocations: (ls: LocationItem[]) => {
            ctx.locations = ls
        },
        is_loading_locations,
        tenant,
        setTenant,
        getTenant,
        all_services,
        services: all_services?.filter((service: ServiceItem) => !service.is_archived),
        getServices,
        stripe_connected_account_id,
        setStripeConnectedAccountId,
        all_staff: denormalizeStaff(all_staff_xhr),
        staff: denormalizeStaff(all_staff_xhr).filter(
            (staff: Staff) => !staff.is_deleted
        ),
        getAllStaff,
        all_memberships: all_memberships_xhr,
        getAllMemberships,
        db_settings,
        getDbSettings,
        primaryColor,
        setPrimaryColor,
        default_booking_url,
        imageDimensions,
        setImageDimensions,
        locationBg,
        setLocationBg,
        preferred_languages,
        refetchCoupons,
        setRefetchCoupons,
        data_item_prices,
        getDataItemPrices,
        tenant_subdomains,
        getTenantSubdomains,
        tenant_integrations,
        getIntegrations,
        bookingPageContent: booking_page_content,
        getBookingPageContent,
        service_categories,
        getServiceCategories,
        membership_categories,
        getMembershipCategories,
        group_classes: group_classes_xhr?.content,
        getGroupClasses,
        payment_integrations,
        getPaymentIntegrations,
        location_payment_integrations,
        toggleFreeTier,
        is_free_tier,
        force_recache_calendar,
        toggleForceRecacheCalendar,
        notification_setting_categories,
        setNotificationSettingCategories,
        getNotificationSettingCategories,
        coupons,
        getCoupons,
        install_prompt,
        show_install,
        calendar_settings,
        setCalendarSettings,
        stripe_promise,
        display_form_title_subtitle,
        toggleDisplayFormTitleSubtitle,
        enable_recurring_bookings,
        toggleEnableRecurringBookings,
        defaultCurrency,
        business_website_url,
        entry_point,
        allow_entry_by_category,
        payment_category,
        business_type,
        referral_type,
        show_services_include,
        intro_message,
        show_intro_border,
        allow_overlap,
        toggleAllowOverlap,
        sidebar_items,
        setSidebarItems,
        getAllMenuSettings,
        getMenuAccess,
        getTenantSubscriptions,
        subscription_tenant_status,
        setSubscriptionTenantStatus,
        active_tenant_obj,
        setActiveTenantObj,
    }

    return (
        <TenantContext.Provider value={ctx}>
            <>{children}</>
        </TenantContext.Provider>
    )
}
